import { isNullish, toEnum } from '../parsing'

export function readStorageString(key: string) {
  return localStorage.getItem(key) ?? undefined
}

export function setStorageString(key: string, value?: string) {
  if (isNullish(value)) {
    localStorage.removeItem(key)
  } else {
    localStorage.setItem(key, value)
  }
}

const TRUE = 'true'
const FALSE = 'false'

export function readStorageBoolean(key: string, defaultValue: boolean) {
  const raw = readStorageString(key)

  return raw === TRUE ? true : raw === FALSE ? false : defaultValue
}

export function setStorageBoolean(key: string, value?: boolean) {
  setStorageString(key, isNullish(value) ? undefined : value ? TRUE : FALSE)
}

export function readStorageEnum<O extends string, D extends O | undefined>(
  key: string,
  options: readonly O[],
  defaultValue: D
) {
  const raw = readStorageString(key)

  return toEnum(raw, options) ?? defaultValue
}

export function setStorageEnum(key: string, value?: string) {
  setStorageString(key, value)
}

export function readStorageJson(key: string) {
  const raw = readStorageString(key)

  if (raw) {
    try {
      return JSON.parse(raw)
    } catch (error) {
      return
    }
  }
}

export function setStorageJson(key: string, value?: any) {
  setStorageString(key, value)

  if (isNullish(value)) {
    setStorageString(key, undefined)

    return
  }

  try {
    setStorageString(key, JSON.stringify(value))
  } catch (error) {
    setStorageString(key, undefined)
  }
}
